import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpDelete from '@opsbase/react-gql-hooks/op/useOpDelete';
import useOpFindById from '@opsbase/react-gql-hooks/op/useOpFindById';
import markdown from '@opsbase/react-markdown';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import Pane from '@opsbase/web-layout/Pane';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import TextField from '@opsbase/web-textfield/TextField';
import Spinner from '@opsbase/web-ui/Spinner';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo, useState } from 'react';
function OpDeleteDialog() {
    const { id } = useParams();
    const dataType = DataType.OP;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const deleteOp = useOpDelete();
    const { loading, data } = useOpFindById({
        variables: { id },
        skip: id === 'selected',
    });
    const [checkTitle, setCheckTitle] = useState();
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const title = id === 'selected' ? selecteds.map(o => o.title).join(', ') : data === null || data === void 0 ? void 0 : data.title;
    const handleAction = useCallback(async () => {
        clearSelection();
        return raise(Promise.all(ids.map(theId => deleteOp({ id: theId }))), i18n.t('op-delete-successful'));
    }, [clearSelection, deleteOp, ids, raise]);
    const text = markdown(i18n.t('confirm-op-delete', {
        title,
        count: ids.length,
    }));
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: i18n.t('delete'), notAgreeText: i18n.t('cancel'), color: Palette.error, loading: loading, canConfirm: checkTitle === i18n.t('delete') },
        React.createElement(Spinner, { busy: loading }, () => (React.createElement(Pane, null,
            React.createElement(Text, null, text),
            React.createElement(TextField, { fullWidth: true, value: checkTitle, onChange: setCheckTitle, placeholder: i18n.t('delete') }))))));
}
export default OpDeleteDialog;
